import ordinal from 'ordinal'
import _ from 'lodash'
import { FormControlLabel, FormGroup, Link, Switch } from '@mui/material'
import { Player } from '../types'
import { useState } from 'react'

interface Props {
  players: Player[]
}

export interface ScoreboardRow {
  text: string
  score: number
}

const scoreboardLink = 'https://darnell766.softr.app'
const targetsBoardLink = 'https://daron729.softr.app'

export const Scoreboard = ({ players }: Props) => {
  const [isInTeamMode, setIsInTeamMode] = useState(true)

  function formatScoreText(scoreboardRows: ScoreboardRow[], index: number) {
    const score = scoreboardRows[index].score
    return (
      index === 0 ?
        ordinal(index + 1)
      : scoreboardRows[index - 1].score === score ?
        `(tied for ${ordinal(index)})`
      :
        `${ordinal(index + 1)} (${
          scoreboardRows[index - 1].score - score
        } behind ${ordinal(index)}!)`
    )
  }

  function formatPlayerNames(playerNames: string[]) {
    return _(playerNames)
      .map((name) => _.startCase(name))
      .join(' & ')
  }

  const scoreboardRows: ScoreboardRow[] =
    isInTeamMode ?
      _(players)
        .groupBy(p => p.teamId)
        .map(teamPlayers => ({
          text: formatPlayerNames(teamPlayers.map(p => p.firstName)),
          score: _.sum(teamPlayers.map(p => p.totalScore))
        })).value()
    :
      players.map(p => ({text: p.firstName, score: p.totalScore}))

  const sortedScoreboardRows = _.orderBy(scoreboardRows, r => r.score, ['desc'])

  return (
    <div style={{ paddingTop: 20, width: '100%', textAlign: 'center' }}>
      <div style={{ marginBottom: 10 }}>
        <h1 style={{ marginBottom: 0 }}>💯 Scoreboard 💯</h1>
        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
          <Link target="_blank" rel="noreferrer" href={scoreboardLink}>
            All scores
          </Link>
          <Link target="_blank" rel="noreferrer" href={targetsBoardLink}>
            Players' targets
          </Link>
        </div>
      </div>
      <div style={{display: 'flex', justifyContent: 'center', marginBottom: 30}}>
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                checked={isInTeamMode}
                onChange={() => setIsInTeamMode(!isInTeamMode)}
              />
            }
            label="Show scores by team"
          />
        </FormGroup>
      </div>
      <div>
        {sortedScoreboardRows.map(({ text, score }, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              flexDirection: 'row',
              margin: '10px 0px',
            }}
          >
            <div style={{ width: '55%', textAlign: 'left' }}>
              {index === 0
                ? '🥇'
                : index === 1
                ? '🥈'
                : index === 2
                ? '🥉'
                : '🤘🏻'}{' '}
              {text}
            </div>
            <div>
              <div style={{ width: '45%', textAlign: 'left' }}>
                {_.round(score)}
              </div>
              <div style={{ fontSize: 'small', textAlign: 'left' }}>
                {formatScoreText(sortedScoreboardRows, index)}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
